export default {
	isProxy: false,  // 是否本地解决跨域
	USER_BASE_URL: 'https://user.tsgyun.com',
	BASE_URL: process.env.VUE_APP_BASE_URL,
	itemName: '现代科研智能辅助平台',
	accessAddress: process.env.VUE_APP_WEB_URL,   // 本项目访问地址
	itemSid: 758,   // 正式
	// itemSid: 768,
	
	mainColor: '#0082FF',    // 设置主色调
	HeaderColor: '#fff',
	HeaderFondColor: '#000',
	mainLightColor: '#F4F7FE',
	headerHeight: 60,
	
	adminItemNmae: '良循后台管理'
}